module.exports = __webpack_public_path__ + "img/artistic_wanderer.6d1c2cb4.png";